// Прехвърляне между складове — заявките, добавени с редизайна: списъкът БЕЗ
// склад (всички прехвърляния на ресторанта за период, по избор и анулираните),
// едно прехвърляне по id и анулирането с причина. Заварените (create, update,
// списъкът ПО СКЛАД) са още в `inventory.ts` и се местят тук при всяка задача,
// която ги докосва. Договорът е в docs/cross-repo-contract.md.
import { api } from "./client";
import type { Transfer } from "./inventory";
import type { DocumentStatusFilter } from "./inventoryPostings";

// Мета полетата от BE с редизайна (липсват при стар BE): кога е ВЪВЕДЕН
// документът и анулирането му. `status` липсва → документът е активен.
export type TransferDocument = Transfer & {
  createdAt?: string | null;
  status?: "active" | "annulled";
  deletedAt?: string | null;
  deletedByName?: string | null;
  deleteReason?: string | null;
};

export type TransfersReportParams = {
  startDate: string;
  endDate: string;
  // без склад → всички прехвърляния на ресторанта (BE филтрира по JWT)
  warehouseId?: number | null;
  status?: DocumentStatusFilter;
};

// Справката „Прехвърляния" и „Прехвърлени днес". Стар BE иска `warehouseId`
// (422 без него) и не знае `status`.
export async function getTransfersReport(
  params: TransfersReportParams,
): Promise<TransferDocument[]> {
  const { warehouseId, ...rest } = params;
  const res = await api.get<TransferDocument[]>("/inventory/transfers", {
    params: warehouseId != null ? { ...rest, warehouseId } : rest,
  });
  return res.data;
}

// Едно прехвърляне (редакция по директен адрес, документ по id)
export async function getTransfer(
  id: number,
  includeDeleted = false,
): Promise<TransferDocument> {
  const res = await api.get<TransferDocument>(`/inventory/transfers/${id}`, {
    params: includeDeleted ? { includeDeleted: true } : undefined,
  });
  return res.data;
}

// Анулиране с причина (незадължителна; стар BE я игнорира)
export async function annulTransfer(
  id: number,
  annulReason: string | null,
): Promise<void> {
  await api.delete(`/inventory/transfers/${id}`, {
    data: annulReason ? { annulReason } : undefined,
  });
}
